/* eslint-disable no-plusplus */
export default function preloadVerification(imageUrls) {
  return new Promise((resolve) => {
    const validImageUrls = imageUrls.filter((url) => url);
    const totalImages = validImageUrls.length;

    if (totalImages === 0) resolve();

    let loadedCount = 0;
    const handleLoad = () => {
      loadedCount++;

      if (loadedCount === totalImages) {
        resolve();
      }
    };

    validImageUrls.forEach((url) => {
      const img = new Image();
      img.src = url;
      img.onload = handleLoad;
      img.onerror = handleLoad;
    });
  });
}
